/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取文件的全部元信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetObjectMetadataParams {
  constructor(public filePath: string) {}
}

export default async function (
  params: GetObjectMetadataParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oss.FileMetaDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oss/fileMeta`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
